(function (app) {

    app.provider("arcPolicyApi",
        [
            function () {
                this.$get = [
                    "crmApiGateway", function (crmApiGateway) {
                        var service = {};

                        service.getPending = function () {
                            return crmApiGateway.get("/ArcPolicies/Pending");
                        };
                        
                        service.exportPending = function () {
                            return crmApiGateway.getFilePost("/ArcPolicies/Pending/Export");
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line